import Vue from 'vue';
import Vuex from 'vuex';
import { DpSentryAddBreadcrumb } from '@docupet/component-library';
import * as order from '@/store/modules/order';
import * as user from '@/store/modules/user';
import * as tagProduct from '@/store/modules/tagProduct';
import * as collarProduct from '@/store/modules/collarProduct';
import * as essentialProduct from '@/store/modules/essentialProduct';
import * as leashProduct from '@/store/modules/leashProduct';
import * as otherProduct from '@/store/modules/otherProduct';
import * as walletCardProduct from '@/store/modules/walletCardProduct';
import * as pets from '@/store/modules/pets';
import * as basket from '@/store/modules/basket';
import * as notification from '@/store/modules/notification';
import * as marketing from '@/store/modules/marketing';

Vue.use(Vuex);

// Grab Initial state or create own for env
const initialState = window.__INITIAL_STATE__ || {
  locale: process.env.VUE_APP_LOCALE || 'en_US',
  token: process.env.VUE_APP_TOKEN || null,
  orderId: process.env.VUE_APP_ORDER_ID || null,
  cityId: process.env.VUE_APP_CITY_ID || null,
  membershipRemovalSurvey: false,
  designerTagRemovalSurvey: false,
  automatedDiscounts: false,
};

initialState.baseUrl = window.BASE_URL || process.env.VUE_APP_BASE_URL;

export default new Vuex.Store({
  modules: {
    order,
    user,
    tagProduct,
    collarProduct,
    essentialProduct,
    leashProduct,
    otherProduct,
    walletCardProduct,
    pets,
    basket,
    notification,
    marketing,
  },
  state: initialState,
  getters: {
    getLocale: ({ locale }) => locale || window.__INITIAL_STATE__.locale || 'en_US',
    getBaseUrl: ({ baseUrl }) => baseUrl || window.BASE_URL || process.env.VUE_APP_BASE_URL,
    getMembershipRemovalSurvey: ({ membershipRemovalSurvey }) => membershipRemovalSurvey || false,
    getDesignerTagRemovalSurvey: ({ designerTagRemovalSurvey }) => designerTagRemovalSurvey || false,
    automatedDiscountsEnabled: ({ automatedDiscounts }) => automatedDiscounts === true,
    isNasnCohort: ({ isNasnCohort }) => isNasnCohort === true,
    generateFullUrl:
      ({ baseUrl, locale }) =>
      (path) =>
        `${baseUrl}/${locale}${path || ''}`,
  },
  plugins: [
    (store) => {
      store.subscribeAction((action, state) =>
        DpSentryAddBreadcrumb('Action', 'info', action?.type || '', {
          ...state,
          token: null,
        })
      );
      store.subscribe((mutation) => DpSentryAddBreadcrumb('Mutation', 'info', mutation?.type || ''));
    },
  ],
});
